/* eslint-disable no-param-reassign */
import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import user from '@/store/modules/user'
import IntervalTimer from '@/plugins/IntervalTimer'
import editor from '@/store/modules/editor'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  state: {
    // header参数-token
    TOKEN: void 0,
    // header参数-项目id
    PROJECT_ID: -1,
    // 选中的项目名称
    PROJECT_NAME: '',
    // header参数-平台类型
    PLATFORM: 'Web',
    // header参数-终端类型
    APPLICATION_HOST_TYPE: '',
    // 全局定时器管理
    intervalTimer: new IntervalTimer(),
    // 路由对象
    ROUTER_PATH: {
      path: '/',
      name: 'Main',
      title: '首页',
      params: {},
      query: {},
    },
    // 菜单map
    MENU_MAP: {
      Login: {
        path: '/login',
        title: '登录',
        name: 'Login',
      },
      Main: {
        path: '/',
        title: '首页',
        name: 'Main',
      },
      Home: {
        path: '/home',
        title: '主界面',
        name: 'Home',
      },
      Register: {
        path: '/register',
        title: '注册',
        name: 'Register',
      },
      ResetPassword: {
        path: '/reset-password',
        title: '忘记密码',
        name: 'ResetPassword',
      },
      MyInvitation: {
        path: '/home/my-invitation',
        title: '成员管理',
        name: 'MyInvitation',
      },
      ProjectInfo: {
        path: '/home/project-info',
        title: '项目信息',
        name: 'ProjectInfo',
      },
      Projects: {
        path: '/home/projects',
        title: '全部项目',
        name: 'Projects',
      },
      QRCodeManagement: {
        path: '/home/qrcode-management',
        title: '二维码管理',
        name: 'QRCodeManagement',
      },
      UserManagement: {
        path: '/home/user-management',
        title: '用户管理',
        name: 'UserManagement',
      },
      Editor: {
        path: '/home/editor',
        title: '富文本编辑',
        name: 'Editor',
      },
    },
  },
  getters: {
    /**
     * 定时任务集合
     * @param state
     * @return {IntervalTimer}
     */
    intervalTimer: state => state.intervalTimer,
    /*
     * 选中的项目ID
     * @parma state
     * @return {number} 项目ID
     * */
    getProjectId: state =>
      state.PROJECT_ID > 0 ? state.PROJECT_ID : window.localStorage.getItem('ProjectID'),
    /*
     * 选中的项目名称
     * @parma state
     * @return {string} 项目名称
     * */
    getProjectName: state =>
      state.PROJECT_NAME ? state.PROJECT_NAME : window.localStorage.getItem('ProjectName'),
  },
  mutations: {
    /**
     * 路由跳转
     * @param state
     * @param payload {object} 路由参数
     */
    setRouter(state, payload) {
      const { name, params, query } = { ...payload }
      const { path } = state.MENU_MAP[name]

      router
        .push({
          path,
          params,
          query,
        })
        .catch(() => {
          // console.error(err)
        })
    },
    /**
     * 保存路由对象参数
     * @param state {Vuex}
     * @param route {Object} 路由参数集合对象
     */
    saveRoutePath(state, route) {
      const options = {
        ...route,
        title: state.MENU_MAP[route.name]?.title ?? '',
      }
      state.ROUTER_PATH = { ...options }
      window.localStorage.setItem('RouterInfo', JSON.stringify({ ...options }))
    },
    /**
     * 设置token
     * @param state {Vuex.State}
     * @param token {string} token
     */
    setToken(state, token) {
      state.TOKEN = token
      window.localStorage.setItem('Token', token)
    },
    /**
     * 设置选中的项目ID，项目名称
     * @param state {Vuex.State}
     * @param payload
     */
    setProjectInfo(state, payload) {
      const { ProjectID, ProjectName } = payload
      state.PROJECT_ID = ProjectID
      state.PROJECT_NAME = ProjectName
      window.localStorage.setItem('ProjectID', ProjectID)
      window.localStorage.setItem('ProjectName', ProjectName)
    },
  },
  actions: {},
  modules: {
    user,
    editor,
  },
  plugins: [],
})
